import { useState, useEffect } from 'react';
import { Table, Switch } from 'antd';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';
import { blockUnblockEventTypeAsync, fetchBlockedEventTypesAsync } from '../../../redux/slice/blockMarkets/blockMarkets';


function EventType() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userdata, isAuthenticated, deletedUsers } = useSelector((state) => state.authSlice);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const { eventTypes } = useSelector((state) => state.blockMarkets);

    const blockUnblockEventType = (event_type) => {
        var data = JSON.stringify({
            "user_id": profileData?._id,
            "event_id": "0",
            "market_id": "0",
            "fancy_id": "0",
            "event_type_id": event_type,
            "type": "Sport"

        });
        if (isAuthenticated) {
            dispatch(blockUnblockEventTypeAsync(data))
                .unwrap()
                .then((response) => {
                    NotificationManager.success(response.message, '', 1000);
                    dispatch(fetchBlockedEventTypesAsync());
                })
                .catch((error) => {
                    console.log(error);
                    // NotificationManager.error(error.message || 'Failed to block/unblock event type', '', 3000);
                });
        }
    }
    const columns = [
        {
            title: 'Name',
            // sorter: true,
            render: (_, record) => (
                <span className='font-extrabold !text-[#315195] text-[0.813rem] ml-[5px] cursor-pointer' onClick={() =>
                    navigate(`/block-events/${record.event_type}`)}
                >
                    {record.name}
                </span>
            ),
        },
        {
            title: 'Status',
            // sorter: true,
            render: (_, record) => (
                <div className='flex items-center gap-x-4 ' >
                    <span className={`flex items-center gap-1 cursor-pointer ${record.is_blocked !== "Yes" ? 'text-[green]' : 'text-[red]'}`}>{record.is_blocked !== "Yes" ? 'Active' : 'Inactive'}</span>
                </div>
            )

        },

        {
            title: 'Action',
            sorter: false,
            render: (_, record) => (
                <div className='flex items-center gap-x-4'>
                    <Switch
                        checked={record.is_blocked === "Yes" ? false : true}
                        onChange={() => blockUnblockEventType(record.event_type)}
                    />
                </div>
            )
        },

    ];
    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchBlockedEventTypesAsync());
        }
    }, [dispatch, isAuthenticated]);
    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12 relative p-[15px] lg:px-[30px]' >
                <div className='col-span-12 lg:mx-auto lg:w-full  '>
                    <div className='grid grid-cols-12'>
                        <div className='col-span-12 '>
                            <div className='pt-[5px] px-[6px] pb-[6px] font-bold text-[14px] !bg-[linear-gradient(#022c43,_#18b0c8)] mb-0 border-b-[1px_solid_#0000002d] !text-[#ffffff] [word-wrap:break-word]'>
                                <span className='relative top-px font-bold text-[0.875rem] !text-[#ffffff]'>Event Types List</span>
                            </div>
                        </div>
                        <div className='col-span-12 '>

                            <div className='bg-[#fff] border-[1px] border-[#0000002d] '>

                                <div className='p-[0.75rem] flex-auto '>
                                    <Table
                                        columns={columns}
                                        className='downline-list'
                                        bordered
                                        dataSource={eventTypes}
                                        pagination={false}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default EventType;
